import { render, staticRenderFns } from "./growersettlement.vue?vue&type=template&id=89d5cd20"
import script from "./growersettlement.vue?vue&type=script&lang=js"
export * from "./growersettlement.vue?vue&type=script&lang=js"
import style0 from "./growersettlement.vue?vue&type=style&index=0&id=89d5cd20&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports